import { render, staticRenderFns } from "./ABAppHeader.vue?vue&type=template&id=2bd79da6&scoped=true&"
import script from "./ABAppHeader.vue?vue&type=script&lang=js&"
export * from "./ABAppHeader.vue?vue&type=script&lang=js&"
import style0 from "./ABAppHeader.vue?vue&type=style&index=0&id=2bd79da6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd79da6",
  null
  
)

export default component.exports